export const VEO_CDN_VIDEO_LINK_EXAMPLE =
	"https://c.veocdn.com/abcdefab-cdef-abcd-efab-cdefabcdefab/panorama/video.ts";

const VEO_CDN_VIDEO_LINK_PATTERN =
	/^https:\/\/(?:[a-z0-9-]+\.)*veocdn\.com\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/panorama\/video\.ts$/i;

export type VeoLinkSource = {
	veoLink?: unknown;
	videoLinks?: ReadonlyArray<{ link: string }>;
};

export const getTrustedVeoLink = (value: unknown): string | null => {
	if (typeof value !== "string") {
		return null;
	}

	const trimmedVeoLink = value.trim();

	if (trimmedVeoLink === "") {
		return null;
	}

	if (VEO_CDN_VIDEO_LINK_PATTERN.test(trimmedVeoLink) === false) {
		return null;
	}

	return trimmedVeoLink;
};

export const findTrustedVeoLink = (source: VeoLinkSource): string | null => {
	const directVeoLink = getTrustedVeoLink(source.veoLink);
	if (directVeoLink !== null) {
		return directVeoLink;
	}

	for (const videoLink of source.videoLinks ?? []) {
		const trustedVeoLink = getTrustedVeoLink(videoLink.link);
		if (trustedVeoLink !== null) {
			return trustedVeoLink;
		}
	}

	return null;
};
